export default __webpack_public_path__ + "static/media/refreshment.90574d98.png";